/* eslint-disable */
// Rewards / Civic economy section — merged into i18n (2-level deep merge).
export const translationsRewards = {
    it: {
        nav: { ricompense: "Ricompense" },
        rewards: {
            eyebrow: "Ricompense",
            claim_a: "Guadagni la reputazione.",
            claim_b: "Non la compri",
            intro: "Due valute distinte, un solo principio: il merito, non il portafoglio. Nessun like da comprare, nessun follower falso, nessun algoritmo che premia chi paga di più.",
            noFiatBadge: "Nessuna ricompensa in denaro",
            noFiat: "I Civic Points non sono convertibili in euro né in alcuna moneta reale: misurano solo la tua reputazione civica.",
            pointsTitle: "Civic Points · la reputazione",
            pointsSubtitle: "Si guadagnano solo con attività genuine e verificate.",
            points: [
                { a: "Pubblicare una segnalazione", b: "+15" },
                { a: "Conferma ricevuta (like)", b: "+2" },
                { a: "Commento ricevuto", b: "+1" },
                { a: "100 visualizzazioni uniche", b: "+10" },
                { a: "Validata da un esperto", b: "+25" },
                { a: "Streak 3 / 7 / 30 giorni", b: "+5 / +15 / +50" },
            ],
            penaltiesTitle: "Come si perdono",
            penalties: [
                { a: "Segnalazione falsa", b: "−30" },
                { a: "Moderazione (1° / 2° blocco 24h)", b: "−15 / −30" },
                { a: "Terzo blocco (stop 6h)", b: "−50" },
                { a: "Inattività (decay al giorno)", b: "−1…−5" },
            ],
            severe: "La reputazione deve costare: un tier alto è credibilità civica reale. Per questo si può anche retrocedere. Non è pay-to-stay, è merito continuo.",
            creditsTitle: "Crediti · lo strumento",
            creditsSubtitle: "Servono per pubblicare oltre la quota e amplificare i post utili. Mai acquistabili con la reputazione.",
            credits: [
                "La prima segnalazione di sempre è gratuita",
                "Piano Free: 1 credito per segnalazione",
                "Premium: 10 segnalazioni/mese · Plus: illimitate + PDF forensi",
                "Boost post: 2 crediti · Boost account: 5 crediti",
                "Conversione controllata: 500 punti = 1 credito, max 1 volta/mese, con avviso di retrocessione",
            ],
            tiersTitle: "La scala Climax",
            tierColThreshold: "Soglia",
            tiers: [
                { name: "Osservatore", th: "0", perk: "Accesso base" },
                { name: "Cittadino", th: "100", perk: "+2 crediti/mese" },
                { name: "Custode", th: "500", perk: "+5 crediti/mese · badge" },
                { name: "Guardiano", th: "2.000", perk: "+10 crediti/mese · priorità AI" },
                { name: "Sentinella", th: "10.000", perk: "+20 crediti/mese · autorità verificata" },
            ],
            principlesTitle: "Perché è diverso",
            principles: [
                { t: "Due valute, due logiche", d: "I punti misurano chi sei. I crediti, cosa fai adesso. Non si confondono mai." },
                { t: "Zero denaro reale", d: "I punti non si comprano, non si vendono, non diventano euro." },
                { t: "Meritocratica e reversibile", d: "Sali con contributi veri, scendi con inattività o abusi." },
                { t: "Niente monetizzazione predatoria", d: "Nessuna FOMO artificiale, nessun pay-to-win, nessun algoritmo oscuro." },
            ],
        },
    },
    en: {
        nav: { ricompense: "Rewards" },
        rewards: {
            eyebrow: "Rewards",
            claim_a: "You earn reputation.",
            claim_b: "You don't buy it",
            intro: "Two distinct currencies, one principle: merit, not your wallet. No likes to buy, no fake followers, no algorithm rewarding whoever pays most.",
            noFiatBadge: "No cash rewards",
            noFiat: "Civic Points are not convertible into euros or any real currency: they only measure your civic reputation.",
            pointsTitle: "Civic Points · reputation",
            pointsSubtitle: "Earned only through genuine, verified activity.",
            points: [
                { a: "Publish a report", b: "+15" },
                { a: "Confirmation received (like)", b: "+2" },
                { a: "Comment received", b: "+1" },
                { a: "100 unique views", b: "+10" },
                { a: "Validated by an expert", b: "+25" },
                { a: "Streak 3 / 7 / 30 days", b: "+5 / +15 / +50" },
            ],
            penaltiesTitle: "How you lose them",
            penalties: [
                { a: "Report flagged as fake", b: "−30" },
                { a: "Moderation (1st / 2nd block 24h)", b: "−15 / −30" },
                { a: "Third block (6h stop)", b: "−50" },
                { a: "Inactivity (daily decay)", b: "−1…−5" },
            ],
            severe: "Reputation must cost something: a high tier means real civic credibility. That's why you can also drop down. It's not pay-to-stay, it's continuous merit.",
            creditsTitle: "Credits · the tool",
            creditsSubtitle: "Used to publish beyond your quota and amplify useful posts. Never buyable with reputation.",
            credits: [
                "Your very first report is always free",
                "Free plan: 1 credit per report",
                "Premium: 10 reports/month · Plus: unlimited + forensic PDFs",
                "Boost post: 2 credits · Boost account: 5 credits",
                "Controlled conversion: 500 points = 1 credit, max once/month, with downgrade warning",
            ],
            tiersTitle: "The Climax ladder",
            tierColThreshold: "Threshold",
            tiers: [
                { name: "Observer", th: "0", perk: "Base access" },
                { name: "Citizen", th: "100", perk: "+2 credits/month" },
                { name: "Keeper", th: "500", perk: "+5 credits/month · badge" },
                { name: "Guardian", th: "2,000", perk: "+10 credits/month · AI priority" },
                { name: "Sentinel", th: "10,000", perk: "+20 credits/month · verified authority" },
            ],
            principlesTitle: "Why it's different",
            principles: [
                { t: "Two currencies, two logics", d: "Points measure who you are. Credits, what you do now. Never mixed." },
                { t: "Zero real money", d: "Points can't be bought, sold or turned into euros." },
                { t: "Meritocratic & reversible", d: "You rise with real contributions, you fall with inactivity or abuse." },
                { t: "No predatory monetisation", d: "No artificial FOMO, no pay-to-win, no dark algorithm." },
            ],
        },
    },
    es: {
        nav: { ricompense: "Recompensas" },
        rewards: {
            eyebrow: "Recompensas",
            claim_a: "Ganas la reputación.",
            claim_b: "No la compras",
            intro: "Dos monedas distintas, un solo principio: el mérito, no la cartera. Sin likes que comprar, sin seguidores falsos, sin algoritmo que premie a quien más paga.",
            noFiatBadge: "Sin recompensas en dinero",
            noFiat: "Los Civic Points no son convertibles en euros ni en ninguna moneda real: solo miden tu reputación cívica.",
            pointsTitle: "Civic Points · la reputación",
            pointsSubtitle: "Se ganan solo con actividad genuina y verificada.",
            points: [
                { a: "Publicar una denuncia", b: "+15" },
                { a: "Confirmación recibida (like)", b: "+2" },
                { a: "Comentario recibido", b: "+1" },
                { a: "100 visualizaciones únicas", b: "+10" },
                { a: "Validada por un experto", b: "+25" },
                { a: "Racha 3 / 7 / 30 días", b: "+5 / +15 / +50" },
            ],
            penaltiesTitle: "Cómo se pierden",
            penalties: [
                { a: "Denuncia marcada como falsa", b: "−30" },
                { a: "Moderación (1º / 2º bloqueo 24h)", b: "−15 / −30" },
                { a: "Tercer bloqueo (stop 6h)", b: "−50" },
                { a: "Inactividad (decay diario)", b: "−1…−5" },
            ],
            severe: "La reputación debe costar: un tier alto es credibilidad cívica real. Por eso también se puede retroceder. No es pay-to-stay, es mérito continuo.",
            creditsTitle: "Créditos · la herramienta",
            creditsSubtitle: "Sirven para publicar más allá de la cuota y amplificar posts útiles. Nunca comprables con la reputación.",
            credits: [
                "Tu primera denuncia siempre es gratis",
                "Plan Free: 1 crédito por denuncia",
                "Premium: 10 denuncias/mes · Plus: ilimitadas + PDF forenses",
                "Boost post: 2 créditos · Boost cuenta: 5 créditos",
                "Conversión controlada: 500 puntos = 1 crédito, máx 1 vez/mes, con aviso de retroceso",
            ],
            tiersTitle: "La escala Climax",
            tierColThreshold: "Umbral",
            tiers: [
                { name: "Observador", th: "0", perk: "Acceso base" },
                { name: "Ciudadano", th: "100", perk: "+2 créditos/mes" },
                { name: "Custodio", th: "500", perk: "+5 créditos/mes · insignia" },
                { name: "Guardián", th: "2.000", perk: "+10 créditos/mes · prioridad IA" },
                { name: "Centinela", th: "10.000", perk: "+20 créditos/mes · autoridad verificada" },
            ],
            principlesTitle: "Por qué es diferente",
            principles: [
                { t: "Dos monedas, dos lógicas", d: "Los puntos miden quién eres. Los créditos, qué haces ahora. Nunca se mezclan." },
                { t: "Cero dinero real", d: "Los puntos no se compran, no se venden, no se vuelven euros." },
                { t: "Meritocrática y reversible", d: "Subes con contribuciones reales, bajas con inactividad o abusos." },
                { t: "Sin monetización predatoria", d: "Sin FOMO artificial, sin pay-to-win, sin algoritmo oscuro." },
            ],
        },
    },
    fr: {
        nav: { ricompense: "Récompenses" },
        rewards: {
            eyebrow: "Récompenses",
            claim_a: "Tu gagnes la réputation.",
            claim_b: "Tu ne l'achètes pas",
            intro: "Deux monnaies distinctes, un seul principe : le mérite, pas le portefeuille. Pas de likes à acheter, pas de faux abonnés, pas d'algorithme qui favorise qui paie le plus.",
            noFiatBadge: "Aucune récompense en argent",
            noFiat: "Les Civic Points ne sont convertibles ni en euros ni en aucune monnaie réelle : ils mesurent seulement ta réputation civique.",
            pointsTitle: "Civic Points · la réputation",
            pointsSubtitle: "Gagnés uniquement par une activité authentique et vérifiée.",
            points: [
                { a: "Publier un signalement", b: "+15" },
                { a: "Confirmation reçue (like)", b: "+2" },
                { a: "Commentaire reçu", b: "+1" },
                { a: "100 vues uniques", b: "+10" },
                { a: "Validé par un expert", b: "+25" },
                { a: "Série 3 / 7 / 30 jours", b: "+5 / +15 / +50" },
            ],
            penaltiesTitle: "Comment on les perd",
            penalties: [
                { a: "Signalement jugé faux", b: "−30" },
                { a: "Modération (1er / 2e blocage 24h)", b: "−15 / −30" },
                { a: "Troisième blocage (stop 6h)", b: "−50" },
                { a: "Inactivité (decay par jour)", b: "−1…−5" },
            ],
            severe: "La réputation doit coûter : un tier élevé, c'est une crédibilité civique réelle. C'est pourquoi on peut aussi redescendre. Ce n'est pas du pay-to-stay, c'est du mérite continu.",
            creditsTitle: "Crédits · l'outil",
            creditsSubtitle: "Servent à publier au-delà du quota et amplifier les posts utiles. Jamais achetables avec la réputation.",
            credits: [
                "Ton tout premier signalement est toujours gratuit",
                "Plan Free : 1 crédit par signalement",
                "Premium : 10 signalements/mois · Plus : illimités + PDF forensiques",
                "Boost post : 2 crédits · Boost compte : 5 crédits",
                "Conversion contrôlée : 500 points = 1 crédit, max 1 fois/mois, avec alerte de rétrogradation",
            ],
            tiersTitle: "L'échelle Climax",
            tierColThreshold: "Seuil",
            tiers: [
                { name: "Observateur", th: "0", perk: "Accès de base" },
                { name: "Citoyen", th: "100", perk: "+2 crédits/mois" },
                { name: "Gardien local", th: "500", perk: "+5 crédits/mois · badge" },
                { name: "Gardien", th: "2 000", perk: "+10 crédits/mois · priorité IA" },
                { name: "Sentinelle", th: "10 000", perk: "+20 crédits/mois · autorité vérifiée" },
            ],
            principlesTitle: "Pourquoi c'est différent",
            principles: [
                { t: "Deux monnaies, deux logiques", d: "Les points mesurent qui tu es. Les crédits, ce que tu fais. Jamais mélangés." },
                { t: "Zéro argent réel", d: "Les points ne s'achètent pas, ne se vendent pas, ne deviennent pas des euros." },
                { t: "Méritocratique et réversible", d: "Tu montes avec de vraies contributions, tu descends avec l'inactivité ou les abus." },
                { t: "Pas de monétisation prédatrice", d: "Pas de FOMO artificiel, pas de pay-to-win, pas d'algorithme obscur." },
            ],
        },
    },
    de: {
        nav: { ricompense: "Belohnungen" },
        rewards: {
            eyebrow: "Belohnungen",
            claim_a: "Du verdienst Reputation.",
            claim_b: "Du kaufst sie nicht",
            intro: "Zwei getrennte Währungen, ein Prinzip: Verdienst, nicht Geldbeutel. Keine kaufbaren Likes, keine Fake-Follower, kein Algorithmus, der Zahlende bevorzugt.",
            noFiatBadge: "Keine Geldbelohnungen",
            noFiat: "Civic Points sind nicht in Euro oder eine reale Währung umwandelbar: sie messen nur deine Bürgerreputation.",
            pointsTitle: "Civic Points · die Reputation",
            pointsSubtitle: "Nur durch echte, verifizierte Aktivität verdient.",
            points: [
                { a: "Eine Meldung veröffentlichen", b: "+15" },
                { a: "Bestätigung erhalten (Like)", b: "+2" },
                { a: "Kommentar erhalten", b: "+1" },
                { a: "100 eindeutige Views", b: "+10" },
                { a: "Von einem Experten validiert", b: "+25" },
                { a: "Streak 3 / 7 / 30 Tage", b: "+5 / +15 / +50" },
            ],
            penaltiesTitle: "Wie man sie verliert",
            penalties: [
                { a: "Als Fake gemeldet", b: "−30" },
                { a: "Moderation (1. / 2. Sperre 24h)", b: "−15 / −30" },
                { a: "Dritte Sperre (6h Stopp)", b: "−50" },
                { a: "Inaktivität (täglicher Decay)", b: "−1…−5" },
            ],
            severe: "Reputation muss etwas kosten: ein hoher Tier bedeutet echte zivile Glaubwürdigkeit. Deshalb kann man auch absteigen. Kein Pay-to-Stay, sondern kontinuierlicher Verdienst.",
            creditsTitle: "Credits · das Werkzeug",
            creditsSubtitle: "Zum Veröffentlichen über das Kontingent hinaus und zum Verstärken nützlicher Posts. Nie mit Reputation kaufbar.",
            credits: [
                "Deine allererste Meldung ist immer kostenlos",
                "Free-Plan: 1 Credit pro Meldung",
                "Premium: 10 Meldungen/Monat · Plus: unbegrenzt + forensische PDFs",
                "Boost Post: 2 Credits · Boost Account: 5 Credits",
                "Kontrollierte Umwandlung: 500 Punkte = 1 Credit, max 1×/Monat, mit Abstiegs-Warnung",
            ],
            tiersTitle: "Die Climax-Leiter",
            tierColThreshold: "Schwelle",
            tiers: [
                { name: "Beobachter", th: "0", perk: "Basiszugang" },
                { name: "Bürger", th: "100", perk: "+2 Credits/Monat" },
                { name: "Hüter", th: "500", perk: "+5 Credits/Monat · Badge" },
                { name: "Wächter", th: "2.000", perk: "+10 Credits/Monat · KI-Priorität" },
                { name: "Schildwache", th: "10.000", perk: "+20 Credits/Monat · verifizierte Autorität" },
            ],
            principlesTitle: "Warum es anders ist",
            principles: [
                { t: "Zwei Währungen, zwei Logiken", d: "Punkte messen, wer du bist. Credits, was du jetzt tust. Nie vermischt." },
                { t: "Null echtes Geld", d: "Punkte werden nicht gekauft, verkauft oder zu Euro." },
                { t: "Meritokratisch & reversibel", d: "Du steigst mit echten Beiträgen, du fällst mit Inaktivität oder Missbrauch." },
                { t: "Keine räuberische Monetarisierung", d: "Kein künstliches FOMO, kein Pay-to-Win, kein obskurer Algorithmus." },
            ],
        },
    },
};
